import RightPopupComponent from "components/RightPopup";

export default class AnketaPopup extends RightPopupComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            question: [],
            answers: [],
            info: {}
        };

        this.state = { ...this.defaultState };
    }

    get popupName() {
        return "ankAdultPopup";
    }

    title = "client.ankAdult";

    show(info, type, hideCb) {
        this.state.info = { ...info };
        this.type = type;
        this.dialogTitle = "client." + type;
        this.hidCb = hideCb;

        super.show();
    }

    async onShow() {
        const { domainId, id, adultAnket, childAnket } = this.state.info;
        const answ = this.type === "ankAdult" ? adultAnket : childAnket;

        const anketaQuestionsResp = await this._request.anketaQuestions.getAll();
        const anketaQuestions = (anketaQuestionsResp?.data || []).filter(it => {
            if (this.type === "ankAdult" && it.anketaId === 1)
                return true;
            if (this.type !== "ankAdult" && it.anketaId === 2)
                return true;
            return false;
        });

        const quest = anketaQuestions.sort((a, b) => a.questionPos - b.questionPos);

        const answersMap = answ.reduce((acc, it) => {
            if (it.anketaQuestionAnswer) {
                const answer = it.value ? it.value : it.anketaQuestionAnswer.id;
                if (it.value || it.anketaQuestionAnswer.title) {
                    acc[it.anketaQuestionAnswer.questionId] = {
                        answer: answer,
                        id: it.id
                    };
                }
            }
            return acc;
        }, {});

        const answers = [...quest.map(it => {
            const row = {
                domainId,
                clientId: id,
                questionsAnswersId: (answersMap[it.id] && typeof answersMap[it.id].answer === 'number') ? answersMap[it.id].answer : null,
                value: (answersMap[it.id] && typeof answersMap[it.id].answer !== 'number') ? answersMap[it.id].answer : null,
                anketaId: this.type === "ankAdult" ? 1 : 2,
                questionId: it.id,
                required: it.required,
                answerId: answersMap[it.id] ? answersMap[it.id].id : null
            };
            return row;
        })];

        const question = [...quest.map(it => {
            it.answer = (answersMap[it.id] && answersMap[it.id].answer) ?? null;
            return it;
        })];

        this.setState({ question, answers });
    }

    getSource(qId) {
        const { question } = this.state;
        const ques = (question.find(it => it.id === qId) || {});
        const { id, type } = ques;
        const source = type === "MANUAL_MULTILINE" ? "textArea" : type === "MANUAL" ? "input" : "radioBlock";
        return source + id;
    }

    save() {
        const { answers } = this.state;

        if (answers.some(it => it.required && !it.questionsAnswersId && !it.value)) {
            answers.forEach(it => {
                if (it.required && (!it.questionsAnswersId && !it.value)) {
                    const source = this.getSource(it.questionId);
                    this[source].validate();
                    console.log("На вопрос не отвечено", it);
                }
            });

            this.showError("client.errReqQuestion");
        } else {
            const filtreAnswer = answers.filter(it => it.questionsAnswersId || it.value).map(it => {
                if (!it.answerId)
                    delete it.answerId;
                return it;
            });

            this.saveSend(filtreAnswer);
        }
    }

    async saveSend(answers) {
        const { adultAnket, childAnket } = this.state.info;

        this._helper.showLoading();

        let resp = {};

        if ((this.type === "ankAdult" && adultAnket.length === 0) || (this.type === "ankChild" && childAnket.length === 0)) {
            resp = await this._request.anketaQuestionnaireStat.addn(answers);
        } else {
            const newAnswers = [];
            const info = answers.reduce((acc, it) => {
                if (!acc)
                    acc = {};
                if (it.answerId) {
                    acc[it.answerId] = {
                        questionsAnswersId: it.questionsAnswersId,
                        value: it.value
                    };
                } else {
                    newAnswers.push(it);
                }
                return acc;
            }, {});
            resp = await this._request.anketaQuestionnaireStat.updateAnswer(info);
            if (newAnswers.length > 0)
                resp = await this._request.anketaQuestionnaireStat.addn(newAnswers);
        }

        this._helper.hideLoading();

        if (resp?.data) {
            this.hide();

            if (this.hidCb?.apply)
                this.hidCb();
        }
    }

    onChangeAnswerRadio(questionId, questionsAnswersId) {
        this.onChangeAnswer(questionsAnswersId, questionId, null);
    }

    onChangeAnswer(questionsAnswersId, questionId, value) {
        const { answers, info, question } = this.state;

        const domainId = info.domainId;
        const clientId = info.id;
        const anketaId = question[0].anketaId;

        const object = { questionsAnswersId, value, domainId, clientId, anketaId, questionId };
        const index = answers.findIndex(item => item.questionId === questionId);

        if (index !== -1)
            answers[index] = { ...answers[index], questionsAnswersId, value };
        else
            answers.push(object);
    }

    setValue(el, answer, source) {
        this[source] = el;
        if (el && answer)
            el.value = answer;
    }

    renderQuest(item) {
        const { type, title, questionAnswers, required, answer, id } = item;

        if (type === "MANUAL_MULTILINE") {
            return this.insertTextarea({
                ref: el => this.setValue(el, answer, "textArea" + id),
                label: title,
                placeHolder: "main.freeComment",
                onChange: this.onChangeAnswer.bind(this, questionAnswers[0].id, questionAnswers[0].questionId),
                required: required ? true : false
            });
        } else if (type === "MANUAL") {
            return this.insertInput({
                ref: el => this.setValue(el, answer, "input" + id),
                label: title,
                placeHolder: "main.freeComment",
                onChange: this.onChangeAnswer.bind(this, questionAnswers[0].id, questionAnswers[0].questionId),
                required: required ? true : false
            });
        } else if (type === "SINGLE") {
            return this.insertRadioBlock({
                ref: el => this.setValue(el, answer, "radioBlock" + id),
                title: title,
                items: questionAnswers.map((it, i) => {
                    const row = {
                        key: i,
                        name: it.title,
                        value: it.id,
                    };
                    return row;
                }),
                onChange: this.onChangeAnswerRadio.bind(this, questionAnswers[0].questionId),
                required: required ? true : false
            });
        }

        return <div></div>;
    }

    renderContent() {
        const { question } = this.state;

        return (
            <div className="anketaPopup flex gap16 col">
                {question?.map((it, i) => (<div key={i}>
                    {this.renderQuest(it)}
                </div>))}
            </div>
        );
    }
}
